import { Socket } from "socket.io-client";

import { socket as mainSocket } from "./socketService";

let socket: Socket;

const connect = (handleConnection: (arg0: boolean) => void) => {
  socket = mainSocket;
  if (socket) handleConnection(true);
  // socket = io(`${SOCKET_LINK}v1/sport`, {
  //     forceNew: true,
  //     extraHeaders: {
  //         Authorization: authHeader() || '',
  //     }
  // })
  // return new Promise((res, _rej) => {
  //     socket.on('connect', () => {
  //         console.log("sport Event connected");
  //         handleConnection(true)
  //         // setTimeout(()=>{
  //         //     joinUser();
  //         // },500)
  //         res(socket);
  //     });
  //     socket.on('disconnect', function () {
  //         console.log("sport Event disconnect");
  //         handleConnection(false)
  //     });
  //     socket.once('connect_error', function () {
  //         console.log("error")
  //     });
  //     socket.once('connect_timeout', function () {
  //     });
  // })
};

const joinSport = (data: any) => {
  socket?.emit("join-sport-room", JSON.stringify(data));
};

const leaveSport = (data: any) => {
  socket?.emit("sport-leave", JSON.stringify(data));
};

const getSportDetails = (setSportData: (arg0: any) => void) => {
  socket?.on("get-sport-details", (data) => {
    if (data && !data.response_error && data.data) {
      setSportData(data.data);
    }
  });
};

const chekUserConnected = (connectToRooms = () => {}) => {
  socket?.on("token-verified", (data) => {
    // console.log("IN users-connected - SPORT", data)
    if (data.data.isVerified) {
      connectToRooms();
    } else {
      // console.log('Its me')

      sessionStorage.clear();

      window.location.replace("/");
    }
  });
};

const disconnect = () => {
  socket?.disconnect();
};

const sportSocket = {
  connect,
  disconnect,
  joinSport,
  leaveSport,
  getSportDetails,
  chekUserConnected,
};

export default sportSocket;
